import { DrogasilBlack } from '../../assets/drogasil/black'
import { DrogasilBlackSymbol } from '../../assets/drogasil/black-symbol'
import { DrogasilColored } from '../../assets/drogasil/colored'
import { DrogasilColoredSymbol } from '../../assets/drogasil/colored-symbol'
import { DrogasilWhite } from '../../assets/drogasil/white'
import { DrogasilWhiteSymbol } from '../../assets/drogasil/white-symbol'
import { LogoWhithoutVariant } from '../without-variants'

export const logos = {
  white: {
    large: <DrogasilWhite width={149} height={48} />,
    huge: <DrogasilWhite width={249} height={64} />,
    enormous: <DrogasilWhite width={349} height={80} />,
  },
  black: {
    large: <DrogasilBlack width={149} height={48} />,
    huge: <DrogasilBlack width={249} height={64} />,
    enormous: <DrogasilBlack width={349} height={80} />,
  },
  colored: {
    large: <DrogasilColored width={149} height={48} />,
    huge: <DrogasilColored width={249} height={64} />,
    enormous: <DrogasilColored width={349} height={80} />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}

export const symbols = {
  white: {
    large: <DrogasilWhiteSymbol width={24} height={48} />,
    huge: <DrogasilWhiteSymbol width={40} height={64} />,
    enormous: <DrogasilWhiteSymbol width={56} height={80} />,
  },
  black: {
    large: <DrogasilBlackSymbol width={24} height={48} />,
    huge: <DrogasilBlackSymbol width={40} height={64} />,
    enormous: <DrogasilBlackSymbol width={56} height={80} />,
  },
  colored: {
    large: <DrogasilColoredSymbol width={24} height={48} />,
    huge: <DrogasilColoredSymbol width={40} height={64} />,
    enormous: <DrogasilColoredSymbol width={56} height={80} />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}
